import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';

// 查询商品信息列表【GET】/payment/product/list
export async function getProductList(params) {
  const url = `/payment/product/list${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /payment/native 支付 post请求 productId: 商品id
export async function paymentNative(params) {
  const url = `/payment/native`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// 查询支付结果
// /payment/order/queryByPayOrderId/{payOrderId}
export async function queryByPayOrderId(payOrderId) {
  const url = `/payment/order/queryByPayOrderId/${payOrderId}`; 
  return await _request({
    method: 'GET',
    url,
  })
}

// /payment/jsapi
// JSAPI支付下单接口
export async function paymentJsApi(params) {
  const url = `/payment/jsapi`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// 获取用户账户有效期
// /payment/account/expireTime 【GET】
export async function getAccountExpireTime() {
  const url = `/staff/authInfo`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 根据code获取openId `/api/miniApp/jsCode2Session?code=${code}`
export async function jsCode2Session(code) {
  const url = `/api/miniApp/jsCode2Session?code=${code}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /payment/product/{productId}
export async function getProductDetail(productId) {
  const url = `/payment/product/${productId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
